<template>
    <div class="lp_Empty">
      <img src="../../assets/images/empty.png" alt="">
      <div class="font">{{ text }}</div>
    </div>
</template>

<script>
  export default {
    name: "lp_Empty",
    props:{
      text:{//文本
        type:String,
        default:'暂无数据...'
      }
    },
    data () {
      return{

      }
    },
    methods: {
      
    },
  }
</script>

<style scoped lang="less">
.lp_Empty{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 30px 0px;
  img{
    max-width: 160px;
    height: auto;
  }
  .font{
      font-family: MicrosoftYaHeiUI;
      font-size: 14px;
      color: #666666;
      margin-top: 36px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/empty/index.vue